// extracted by mini-css-extract-plugin
module.exports = {"section_tech":"technology_section_tech__ZNMCk","sub_title":"technology_sub_title__YhUau","image_wrapper":"technology_image_wrapper__b_fRv"};